import ReactGA from 'react-ga4'

const isTest = process.env.NODE_ENV === 'test'
const isDevelopment = process.env.NODE_ENV === 'development'

let initialized = false
function initializeGA() {
  if (initialized) {
    return
  }
  initialized = true
  ReactGA.initialize('G-S6H5C7SEQ6', {
    testMode: isDevelopment || isTest,
  })
}

function send(...args: Parameters<typeof ReactGA.send>): void {
  initializeGA()
  ReactGA.send(...args)
}

function event(...args: Parameters<typeof ReactGA.event>): void {
  initializeGA()
  ReactGA.event(...args)
}

function set(...args: Parameters<typeof ReactGA.set>): void {
  initializeGA()
  ReactGA.set(...args)
}

export default { send, event, set }
